import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class WebsitelandingStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.websites = [];
  }

  handleLoadSuccess(websites) {
    this.websites = websites;
    this.emitChange();
  }

  handleMore(websites) {
    for (var obj in this.websites) {
      if (this.websites[obj].name == websites.name) {
        this.websites[obj].entitiesList = websites.entitiesList;
      }
    }
    this.emitChange();
  }

  get() {
    return this.websites;
  }

  dehydrate() {
    return {
      websites: this.websites
    };
  }

  rehydrate(state) {
    this.websites = state.websites;
  }
}

WebsitelandingStore.storeName = 'WebsitelandingStore';
WebsitelandingStore.handlers = {
  [Actions.LOAD_WEBSITE_SUCCESS]: 'handleLoadSuccess',
  [Actions.LOAD_WEBSITEMORE_SUCCESS]: 'handleMore'
};

export default WebsitelandingStore;


// WEBPACK FOOTER //
// ./src/stores/WebsitelandingStore.js